export default "__VITE_ASSET__1956bed7__"